
import { Button, CircularProgress, FormControl, Grid } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle, UploadCloud, XCircle } from 'react-feather'

// Imports custom
import { FileManagerInput } from 'common'
import { FilesTable } from './FilesTable'
import { LinearLoading } from 'common'


const acceptConfiguration = {
    'application/pdf': []
}

const FormStepFiles = ({useFetchInit}) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { stepApplilication, formOpeningMode } = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormRequestGlobal } = Forms
    const { onDropZoneAcceptedFilesChange, onDropZoneRejectionsFilesChange, formState  } = FormRequestGlobal
    
    // ------------------------------------------------ FetchData
    const { fetchAllDeposits } = FetchData
    const { executeFetchAllDeposits } = fetchAllDeposits

    // ------------------------------------------------ Actions
    const { handleClickReturnStep, handleClickCleanUpFiles, handleClickNextStep, onSubmitFormFiles, pending } = Actions


    return ( 
        <>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2 }}>
                    <form onSubmit={onSubmitFormFiles}>
                        <div className="text-center">
                            <Button
                                startIcon= {pending.submitFiles ? <CircularProgress size={16} color="inherit" /> : <UploadCloud/>}
                                variant="contained"
                                type="submit"
                                className='btn-round'
                                color='primary'
                                sx={{ marginRight: 3, marginLeft: 1 }}
                                disabled={ (formOpeningMode === 'READONLY') || pending.submitFiles }
                            >
                                Subir
                            </Button>
                            <Button
                                startIcon={<XCircle/>}
                                variant="contained"
                                type="button"
                                className='btn-round'
                                color='error'
                                onClick={handleClickCleanUpFiles}
                                sx={{ marginRight: 3, marginLeft: 1 }}
                                disabled={ (formOpeningMode === 'READONLY') ? true : false }
                            >
                                Limpiar
                            </Button>
                        </div>
                        <FormControl fullWidth>
                            <label htmlFor="attachmentt"> * Documentos para enviar a revisión </label>
                            {formOpeningMode !== 'READONLY' && (
                                <FileManagerInput
                                    // datos (listados, individuales)
                                    acceptedFiles={formState.acceptedFiles}
                                    fileRejections={formState.fileRejections}
                                    NameId='attachmentt'
                                    typeFiles='PDF' 
                                    maxFiles={4}
                                    accept={acceptConfiguration}

                                    // HandleClicks

                                    // Funciones
                                    setAcceptedFiles={onDropZoneAcceptedFilesChange}
                                    setFileRejections={onDropZoneRejectionsFilesChange}
                                />
                            )}
                        </FormControl>
                    </form>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8} sx={{ mb: 2 }}>
                {/* {loadingFetchInfoFiles && ( <LinearLoading /> )} */}
                    <FilesTable
                        useFetchInit = {useFetchInit}
                    />
                </Grid>
            </Grid>
            <div className="border-bottom border-secondary m-3"></div>
            <div className="text-center">
                {stepApplilication !== 0 && (
                    <Button 
                        startIcon={<ArrowLeftCircle/>}
                        variant="contained"
                        type="button" 
                        className='btn-round'
                        color='warning'
                        onClick={handleClickReturnStep} 
                        sx={{ marginRight: 1, marginLeft:    1 }}
                    >
                        Volver
                    </Button>
                )}

                <Button
                    endIcon={<ArrowRightCircle/>}
                    variant="contained"
                    type="button"
                    className='btn-round'
                    color='primary'
                    sx={{ marginRight: 1, marginLeft: 1 }}
                    onClick={() => {
                        executeFetchAllDeposits()
                        handleClickNextStep()
                    }}
                >
                    {stepApplilication === 4 ? 'Finalizar' : 'Continuar'}
                </Button>
            </div>
        </>
    )
    
}

export {
    FormStepFiles
}